/**
 * A sealed company's lifecycle status (119-01 `startup_lifecycle.status`) —
 * the pure vocabulary, importable without the Supabase client. Re-exported by
 * ./public-card.
 */

export const LIFECYCLE_STATUSES = ['closed', 'acquired', 'bankrupt'] as const;
export type LifecycleStatus = (typeof LIFECYCLE_STATUSES)[number];

export function isLifecycleStatus(v: unknown): v is LifecycleStatus {
  return typeof v === 'string' && (LIFECYCLE_STATUSES as readonly string[]).includes(v);
}

export const LIFECYCLE_LABEL: Record<LifecycleStatus, string> = {
  closed: 'Closed',
  acquired: 'Acquired',
  bankrupt: 'Bankrupt',
};
